import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const META_PIXEL_ID = process.env.REACT_APP_META_PIXEL_ID;
const MetaPixel = ({ consentGiven }) => {
  const location = useLocation();
  useEffect(() => {
    if (!consentGiven || !META_PIXEL_ID) return undefined;
    if (!window.fbq) {
      const fbq = function () {
        if (fbq.callMethod) fbq.callMethod.apply(fbq, arguments);
        else fbq.queue.push(arguments);
      };
      fbq.queue = []; fbq.loaded = true; fbq.version = "2.0";
      fbq.push = fbq;
      window.fbq = fbq; window._fbq = fbq;
    }
    window.fbq("consent", "grant");
    if (!window.__ppMetaInitialized) {
      window.fbq("init", META_PIXEL_ID);
      window.__ppMetaInitialized = true;
    }
    if (!document.getElementById("pp-meta-sdk")) {
      const script = document.createElement("script");
      script.id = "pp-meta-sdk";
      script.async = true;
      script.src = "https://connect.facebook.net/en_US/fbevents.js";
      if (window.cspNonce) script.setAttribute("nonce", window.cspNonce);
      document.head.appendChild(script);
    }
    return () => { window.fbq?.("consent", "revoke"); };
  }, [consentGiven]);
  useEffect(() => {
    if (consentGiven && META_PIXEL_ID) window.fbq?.("track", "PageView");
  }, [location.pathname, consentGiven]);
  return null;
};
export default MetaPixel;
